/* Custom Input Component to be used with Formik */
import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Text, FormErrorMessage, FormFieldInfo } from 'components/atoms';
import { MediaInputAlt } from 'components/molecules';

// this spacing is used below the error message, this makes the margin feel more natural
// when the error happears and disappears
const InputSpacingFix = styled.div`
  height: ${props => props.theme.spacing.m};
  width: 100%;
`;

const FieldImageUpload = ({
  className,
  title,
  field,
  form: { errors, setFieldValue },
  info,
  isFormActive,
  imageUrl
}) => {
  const isError = useMemo(() => errors[field.name], [errors, field.name]);

  const handleChange = value => {
    setFieldValue(field.name, value);
  };

  return (
    <div className={className}>
      <Top>{title && <Text modifiers={['base']}>{title}</Text>}</Top>
      <ImageWrapper>
        <MediaInputAlt
          onChange={handleChange}
          initialFile={field.value}
          isFormActive={isFormActive}
          initialImage={imageUrl}
        />
      </ImageWrapper>
      {isError && <FormErrorMessage>{errors[field.name]}</FormErrorMessage>}
      {info && <FormFieldInfo>{info}</FormFieldInfo>}
      <InputSpacingFix />
    </div>
  );
};

FieldImageUpload.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    isSubmitting: PropTypes.bool,
    isValid: PropTypes.bool,
    setFieldValue: PropTypes.func,
  }).isRequired,
  info: PropTypes.string,
  isFormActive: PropTypes.bool,
  imageUrl: PropTypes.shape({})
};

FieldImageUpload.defaultProps = {
  className: '',
  title: null,
  info: null,
  isFormActive: false,
  imageUrl: {}
};

const Top = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const ImageWrapper = styled.div`
  height: 300px;
`;

export default styled(FieldImageUpload)`
  ${Text} {
    padding-bottom: ${props => props.theme.spacing.s};
  }
`;
